<template>
    <div id="home" style="overflow-x: hidden">
      <MonitorHeader v-on:childByValue="childByValue"></MonitorHeader>
      <OrderFailureRate v-if="tabName == '1'"> </OrderFailureRate>
      <OrderFollowUp v-if="tabName == '2'"> </OrderFollowUp>
    </div>
  </template>
  
  <script>
  import MonitorHeader from "@/views/monitor/MonitorHeader";
  import OrderFailureRate from "@/views/monitor/orderFailureRate";
  import OrderFollowUp from "@/views/monitor/orderFollowUp";
  export default {
    name: "HBEConfig",
    components: {
      MonitorHeader,
      OrderFollowUp,
      OrderFailureRate,
    },
    data() {
      return {
        tabName: "1",
      };
    },
    methods: {
      childByValue: function (tab) {
        this.tabName = tab;
      },
      
    },
  };
  </script>
  
  <style scoped>
  /* .hotel_container {
    height: 100%;
  } */
  ::v-deep .el-button--primary {
    color: #fff;
    background-color: #e6a23c;
    border-color: #e6a23c;
  }
  ::v-deep .el-form-item__error {
    margin-left: 85px;
  }
  
  /deep/
    .el-form-item.is-required:not(.is-no-asterisk)
    > .el-form-item__label:before {
    content: " ";
    width: 0px;
    margin-right: 0px;
  }
  
  /*dialog*/
  .select-btn {
    color: #fc6640;
    cursor: pointer;
  }
  
  .search-btn {
    margin: 2% 5%;
  }
  
  .search-input {
    margin-left: 10%;
  }
  
  .myBtn /deep/ .el-button {
    padding: 7px 20px !important;
    border: 1px solid #fc6640 !important;
    color: #fc6640 !important;
  }
  
  ::v-deep .dialog-one .el-dialog__body {
    padding: 0px;
  }
  
  ::v-deep .el-input__inner {
    height: 2.7rem;
    line-height: 2.7rem;
  }
  
  
  ::v-deep .el-input__icon {
    height: auto;
    width: 2.5rem;
    text-align: center;
    line-height: 0;
  }
  
  .myselect_inner /deep/ .el-input__inner {
    height: 2.7rem;
    border-radius: 0;
    margin-top: 0.5rem;
  }
  
  .myicon_inner /deep/ .el-input__suffix {
    /*top: 0.7rem;*/
  }
  
  .pos {
    margin-left: 2rem;
    font-size: 1.5rem;
    font-weight: bold;
    border-bottom-color: gainsboro;
    border-bottom-style: solid;
    /*margin-top: 1rem;*/
    padding: 1rem 0 1rem 0;
  }
  .fontcenter {
    display: flex;
    align-items: center;
    margin-left: 1rem;
    font-size: 1.3rem;
  }
  /*HarpID*/
  ::v-deep .btn-custom-cancel {
    float: right;
    margin-left: 10px;
    /*margin-right: 90px;*/
  }
  .btn-custom-cancel {
    float: right;
    margin-left: 0px;
    margin-right: 90px;
  }
  .harpIDbtn {
    width: 10rem;
    height: 3rem;
    padding: 0 !important;
    font-size: 1rem !important;
  }
  </style>
  